module.exports = __webpack_public_path__ + "img/alte_orgel.70d07be1.jpg";